<template>
  <section class="flow">
    <router-link :to="{ path: `/${langPath}howtojoin` }">
      <h3 class="flow__participation">
        {{ DataFlowParticipation.title[lang] }}
      </h3>
      <ol class="flow__list">
        <li class="flow__list--item">
          <img
            src="../../../assets/images/flow/step_01.svg"
            alt=""
            width="140px"
            height="150px"
          />
          <p
            class="flow-sentence"
            v-html="DataFlowParticipation.flows[0].download[lang]"
          ></p>
        </li>
        <li class="flow__list--item">
          <img
            src="../../../assets/images/flow/step_02.svg"
            alt=""
            width="140px"
            height="150px"
          />
          <p
            class="flow-sentence"
            v-html="DataFlowParticipation.flows[1].entry[lang]"
          ></p>
        </li>
        <li class="flow__list--item">
          <router-link
            class="border-important"
            :to="{ path: `/${langPath}confirmation` }"
          ></router-link>
          <p class="important">
            {{ DataFlowParticipation.important[lang] }}
          </p>
          <img
            src="../../../assets/images/flow/step_03.svg"
            alt=""
            width="140px"
            height="150px"
          />
          <p class="flow-sentence">
            {{ DataFlowParticipation.flows[2].coop[lang] }}
          </p>
          <p class="app-sync">
            <img
              class="img-triangle"
              src="../../../assets/images/triangle-right-purple.svg"
              alt=""
            />
            {{ DataFlowParticipation.appSync[lang] }}
          </p>
        </li>
        <li class="flow__list--item">
          <img
            src="../../../assets/images/flow/step_05.svg"
            alt=""
            width="140px"
            height="150px"
          />
          <p class="flow-sentence">
            {{ DataFlowParticipation.flows[3].save[lang] }}
          </p>
        </li>
        <li class="flow__list--item">
          <img
            src="../../../assets/images/flow/step_06.svg"
            alt=""
            width="140px"
            height="150px"
          />
          <p class="flow-sentence">
            {{ DataFlowParticipation.flows[4].ranking[lang] }}
          </p>
        </li>
      </ol>
    </router-link>
  </section>
</template>

<script>
import DataFlowParticipation from "../../../assets/constants/top/flow-participation";
export default {
  data() {
    return {
      DataFlowParticipation: DataFlowParticipation,
    };
  },
  props: {
    lang: {
      type: String,
    },
    langPath: {
      type: String,
    },
  },
  name: "FlowParticipation",
};
</script>

<style scoped>
.flow {
  padding: 48px 30px 40px 30px;
  text-align: center;
  box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.16);
  &:hover {
    box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.2);
    transition-duration: 0.3s;
  }
  &__participation {
    font-size: 40px;
  }
  &__list {
    margin: 60px 0 0 0;
    display: flex;
    justify-content: center;
    &--item {
      position: relative;
      &:not(:first-of-type) {
        margin: 0 0 0 60px;
        max-width: 140px;
        &::before {
          content: "";
          display: inline-block;
          width: 17px;
          height: 33px;
          background: url("../../../assets/images/triangle-right.png") no-repeat
            center / 17px 33px;
          position: absolute;
          top: 75px;
          left: -30px;
          transform: translate(-50%, -50%);
        }
      }
      .flow-sentence {
        margin: 6px 0 0 0;
        min-height: 75px;
        line-height: 1.44;
        font-size: 18px;
        font-weight: bold;
      }
      .app-sync {
        margin: 12px 0 0 0;
        display: flex;
        justify-content: center;
        font-weight: bold;
        .img-triangle {
          margin: 0 4px 0 0;
        }
      }
      .border-important {
        display: block;
        width: 160px;
        height: 300px;
        border: solid 1px #ffbc00;
        position: absolute;
        top: -20px;
        left: 50%;
        transform: translateX(-50%);
      }
      .important {
        width: 110px;
        padding: 4px 0;
        font-size: 20px;
        font-weight: bold;
        color: #fff;
        background-color: #ffbc00;
        position: absolute;
        top: -34px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/top/FlowParticipation.vue